module.exports = __webpack_public_path__ + "img/pin_transport_purple.cdcfa237.svg";